const PLACEHOLDER_DATA_HOOK = 'slot-placeholder';
export const buildUniqueSlotId = (hostCompId, slotId) => {
    return `${hostCompId}.${slotId}`;
};
export const buildSlotPlaceholderDataHook = (slotId, repeatedItemId) => {
    const dataHook = `${PLACEHOLDER_DATA_HOOK}-${slotId}`;
    return repeatedItemId ? `${dataHook}-${repeatedItemId}` : dataHook;
};
//# sourceMappingURL=buildUniqueSlotId.js.map